"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _groupBy2 = _interopRequireDefault(require("lodash/groupBy"));
var _hotelInfo = _interopRequireDefault(require("@tajawal/web-hotel-sdk-v2/lib/stores/hotel-info.store"));
var _adSolution = _interopRequireDefault(require("@tajawal/web-core-sdk-v2/lib/stores/ad-solution.store"));
var _sale = require("./sale.store");
var _crossSellApiAsync = _interopRequireDefault(require("./cross-sell-api-async"));
var _crossSellApiPoll = _interopRequireDefault(require("./cross-sell-api-poll"));
var _saleFactory = require("../factories/sale-factory");
var _constants = require("../constants");
var _sale2 = require("../utils/sale.utils");
var _walletHistory = _interopRequireDefault(require("./wallet-history.store"));
var _class; // stores
// @TODO when we update sdk on desktop & mweb update this to myaccount skd order store
// utils
// constants
/** *
 *  ManageOrderFlightBookingPageStore
 */
let BookingConfirmationPageStore = (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function BookingConfirmationPageStore(initialState = {}, $env) {
    var _$env$config;
    (0, _classCallCheck2.default)(this, BookingConfirmationPageStore);
    this.$env = $env;
    this.updateInitialState(initialState);
    this.sale = new _sale.MyAccountSaleStore(initialState.sale, $env);
    this.hotelInfo = new _hotelInfo.default(initialState.hotelInfo, $env);
    this.crossSellApiAsync = new _crossSellApiAsync.default(initialState.crossSellApiAsync, $env);
    this.crossSellApiPoll = new _crossSellApiPoll.default(initialState.crossSellApiPoll, $env);
    // new ad Butler
    this.adSolution = new _adSolution.default({}, $env, (_$env$config = $env.config) !== null && _$env$config !== void 0 && _$env$config.isMobile ? _constants.AD_SOLUTION_PATH.MWEB : _constants.AD_SOLUTION_PATH.DESKTOP);
    this.walletHistory = new _walletHistory.default(initialState.walletHistoryStore, $env);
  }

  /**
   * update initial state
   * @param {Object} initialState
   */
  (0, _createClass2.default)(BookingConfirmationPageStore, [{
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }

    /**
     * main product
     * @return {Array<Object>}
     */
  }, {
    key: "displayStatus",
    get: function () {
      var _this$sale$data$booki;
      const product = (_this$sale$data$booki = this.sale.data.bookings) === null || _this$sale$data$booki === void 0 ? void 0 : _this$sale$data$booki.filter(booking => Object.values(_constants.MAIN_PRODUCT_TYPES).includes(booking.type))[0];
      return product === null || product === void 0 ? void 0 : product.displayStatus;
    }

    /**
     * valid products
     * @return {Array<Object>}
     */
  }, {
    key: "productsGroups",
    get: function () {
      var _this$sale$data$booki2;
      const factories = (_this$sale$data$booki2 = this.sale.data.bookings) === null || _this$sale$data$booki2 === void 0 ? void 0 : _this$sale$data$booki2.map(booking => (0, _saleFactory.saleFactory)(booking, this.$env));
      const groups = (0, _groupBy2.default)(factories, item => {
        var _item$additionalData, _item$additionalData$;
        return ((_item$additionalData = item.additionalData) === null || _item$additionalData === void 0 ? void 0 : (_item$additionalData$ = _item$additionalData.relatedToOrder) === null || _item$additionalData$ === void 0 ? void 0 : _item$additionalData$.orderId) || item._id;
      });
      return groups;
    }

    /**
     * @typedef {Object} Reward
     * @property {number} value
     * @property {number} points
     * @property {Date} expiryDate
     * @property {string} method
     * @property {string} identifier
     *
     * reward
     * @return {Reward}
     */
  }, {
    key: "reward",
    get: function () {
      const reward = (0, _sale2.getSaleReward)(this.sale);
      return reward;
    }

    /**
     * wallet balance
     * @return {number}
     */
  }, {
    key: "walletBalance",
    get: function () {
      var _this$walletHistory$d, _this$walletHistory$d2, _this$walletHistory$d3;
      return ((_this$walletHistory$d = this.walletHistory.data) === null || _this$walletHistory$d === void 0 ? void 0 : (_this$walletHistory$d2 = _this$walletHistory$d.data) === null || _this$walletHistory$d2 === void 0 ? void 0 : (_this$walletHistory$d3 = _this$walletHistory$d2.availableBalance) === null || _this$walletHistory$d3 === void 0 ? void 0 : _this$walletHistory$d3.points) || 0;
    }
  }]);
  return BookingConfirmationPageStore;
}(), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayStatus", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayStatus"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "productsGroups", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "productsGroups"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "reward", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reward"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "walletBalance", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "walletBalance"), _class.prototype)), _class);
exports.default = BookingConfirmationPageStore;